import React from 'react'
import { Box, Button, Fade } from '@mui/material'

type Props = {
  currentStep: number
  hasAboutYouData: boolean
  isProcessingPayment: boolean
  subscriptionPaymentSuccess?: boolean
  planSelected?: boolean
  onBack: () => void
  onNext: (mode: 'skip' | 'save') => void
}

const OnboardingNavigation: React.FC<Props> = ({
  currentStep,
  hasAboutYouData,
  isProcessingPayment,
  subscriptionPaymentSuccess,
  planSelected,
  onBack,
  onNext,
}) => {
  // Once a plan is picked, the Subscription Agreement panel owns
  // progression past step 3 (its own "Activate subscription" button) —
  // suppress the generic Next/Skip button so there's a single CTA.
  const showNext = currentStep < 4 && !(currentStep === 3 && planSelected)
  const isSkipAction = currentStep === 0 && !hasAboutYouData
  const primaryLabel = isSkipAction
    ? 'Skip'
    : currentStep === 3
      ? subscriptionPaymentSuccess
        ? 'Next'
        : 'Skip'
      : currentStep === 0
        ? 'Next'
        : 'Save & Next'
  const isDisabled = currentStep === 3 ? isProcessingPayment : false

  return (
    <Fade in timeout={800} style={{ transitionDelay: '1200ms' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: showNext ? 'space-between' : 'flex-start',
          mt: 6,
        }}
      >
        <Button
          onClick={onBack}
          sx={{
            color: 'grey.600',
            '&:hover': {
              bgcolor: 'grey.50',
            },
          }}
        >
          Back
        </Button>

        {showNext && (
          <Button
            variant={primaryLabel === 'Skip' ? 'outlined' : 'contained'}
            onClick={() => onNext(primaryLabel === 'Skip' ? 'skip' : 'save')}
            disabled={isDisabled}
            sx={{
              bgcolor: primaryLabel === 'Skip' ? 'transparent' : '#7A6FA1',
              color: primaryLabel === 'Skip' ? 'grey.600' : 'white',
              borderColor: primaryLabel === 'Skip' ? 'grey.300' : '#7A6FA1',
              px: 4,
              py: 1.5,
              fontSize: '1rem',
              fontWeight: 600,
              borderRadius: 2,
              '&:hover': {
                bgcolor: primaryLabel === 'Skip' ? 'grey.50' : '#7A6FA1',
                borderColor: primaryLabel === 'Skip' ? 'grey.400' : '#7A6FA1',
              },
              '&.Mui-disabled': {
                bgcolor: 'grey.300',
                color: 'grey.500',
              },
            }}
          >
            {primaryLabel}
          </Button>
        )}
      </Box>
    </Fade>
  )
}

export default OnboardingNavigation

